<div class="appContentsContainer">
  <div
    id="mantenimientoContainer"
    class="backgroundSand container fullWidthContainer listPage"
  >
    <div class="pageTitle">{{ "printsFormats.titleList" | translate }}</div>
    <app-table
      class="filterTableContainer"
      [tableList]="tableList"
      [elementList]="printFormats"
      [routing]="routing"
      [numPages]="numPages"
      [numElements]="numElements"
      [totalElements]="totalElements"
      [filterParams]="filtersTableJSON"
      [options]="options"
      (valueFilterTable)="filterTable($event)"
      (elementsToRemove)="removeElements($event)"
    ></app-table>
  </div>
</div>
